import { render, staticRenderFns } from "./DashboardOverview.vue?vue&type=template&id=126d0f95&scoped=true&"
import script from "./DashboardOverview.vue?vue&type=script&lang=js&"
export * from "./DashboardOverview.vue?vue&type=script&lang=js&"
import style0 from "./DashboardOverview.vue?vue&type=style&index=0&id=126d0f95&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126d0f95",
  null
  
)

export default component.exports